import React from 'react';
import { Section } from 'common';
import strings from 'strings';

import { SummaryText } from './Summary.styled';

export const Summary = ({ summary = null }) => {
  return (
    <Section title={strings.candidates.profile.resumeTab.sections.summary.title}>
      <SummaryText component="pre" variant="body1">
        {summary || strings.candidates.profile.resumeTab.sections.summary.empty}
      </SummaryText>
    </Section>
  );
};
